import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { filter, map, take, tap } from 'rxjs/operators'
import { DynamicRoutesService, NavSupportService } from '../../modules/app-menu'

/** This component is used as routing target in case the target route is unknown an the dynamic routes are
 * not yet initialized.
 * After the initialization of the dynamic routes this component will initiate a routing to the original url.
 * (if the URL was not added with the dynamic routes, then the user will be send to the NotFoundComponent.)
 */
@Component({
  selector: 'jml-lib-dyn-route-init',
  templateUrl: './dyn-route-init.component.html',
  styleUrls: ['./dyn-route-init.component.scss']
})
export class DynRouteInitComponent implements OnInit {
  targetUrl$: Observable<string>
  constructor(
    private dynamicRoutesService: DynamicRoutesService,
    private navSupportService: NavSupportService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.targetUrl$ = this.navSupportService.desiredUrl$.pipe(
      map((routeData) => (typeof routeData.url === 'string' ? routeData.url : routeData.url.join('/')))
    )

    this.dynamicRoutesService.dynamicRoutesAreInitialized$
      .pipe(
        filter((value) => value),
        take(1),
        tap(() => this.navSupportService.navigateToDesiredUrl(this.router))
      )
      .subscribe()
  }
}
